import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Stack } from 'xen-ui';
import { DocumentList, Dropzone } from 'xen/components';
import { useUploadPaymentDocument } from 'xen/_modules/invoice-settlements/api';
export const PaymentFileManager = ({ payment }) => {
    const { mutate: uploadPaymentDocument, isError, isPending } = useUploadPaymentDocument();
    const uploadDocument = ({ file }) => uploadPaymentDocument({ id: payment.id, file });
    return (_jsxs(Stack, { children: [_jsx(Heading, { level: 3, size: "h5", children: "Documents" }), _jsx(Dropzone, { isError: isError, isLoading: isPending, uploadFile: uploadDocument }), payment.documents.length > 0 && _jsx(DocumentList, { documents: payment.documents })] }));
};
